import { BaseCustomElement } from "brut-js"
import FormDisable from "./FormDisable"
import MealSearch from "./MealSearch"

class Details {
  constructor(page,logger) {
    this.page = page
    this.logger = logger
  }

  open() {
    const element = this.page.querySelector("details")
    if (element) {
      element.setAttribute("open","")
    }
    else {
      this.logger.info("Could not find a <details> element on the page")
    }
    const descriptionField = this.page.querySelector("[name=description]")
    if (descriptionField) {
      descriptionField.focus()
    }
  }
  close() {
    const element = this.page.querySelector("details")
    if (element) {
      element.removeAttribute("open")
    }
    else {
      this.logger.info("Could not find a <details> element on the page")
    }
  }
}
class EatingOutRadioButtons {
  constructor(page,logger) {
    this.page = page
    this.logger = logger
  }

 onEatingOut(listener) {
    const formDisable = this.page.querySelector(FormDisable.tagName)
    if (formDisable) {
      formDisable.addEventListener("disable",listener)
    }
    else {
      this.logger.info("Could not find %s on page",FormDisable.tagName)
    }
  }
  onNotEatingOut(listener) {
    const formDisable = this.page.querySelector(FormDisable.tagName)
    if (formDisable) {
      formDisable.addEventListener("enable",listener)
    }
    else {
      this.logger.info("Could not find %s on page",FormDisable.tagName)
    }
  }
}

class NewPlanByDatePage extends BaseCustomElement {
  static tagName = "cc-new-plan-by-date-page"

  static observedAttributes = [
    "show-warnings",
    "state",
  ]

  constructor() {
    super()
    this.#details               = new Details(this)
    this.#eatingOutRadioButtons = new EatingOutRadioButtons(this)
  }

  #details = null
  #eatingOutRadioButtons = null
  #state = "fresh"
  #previousState = "fresh"

  stateChangedCallback({newValue}) {
    this.#previousState = this.#state
    this.#state = (newValue && newValue != "") ? newValue : "fresh"
  }

  #eatingOutSelected = () => {
    this.setAttribute("state","eating-out")
  }
  #notEatingOutSelected = () => {
    this.setAttribute("state",this.#previousState)
  }
  #addNew = (event) => {
    const name = event.detail.name
    this.querySelector("form").reset()
    const nameField = this.querySelector("input[name=name]")
    if (!nameField) {
      this.logger.info("no field with name=name - this won't work")
      return
    }
    nameField.value = name

    this.setAttribute("state","creating")
  }

  #previousMealSelected = (event) => {
    const form = this.querySelector("form")
    if (!form) {
      this.logger.info("Something's wrong, cannot find a <form>")
      return
    }
    for( const[name,value] of Object.entries(event.detail)) {
      const element = form.elements[name]
      if (element) {
        if (element.tagName == "SELECT") {
          element.querySelectorAll("option").forEach( (option) => {
            if (option.value == value) {
              option.selected = true
            }
            else {
              option.selected = false
            }
          })
        }
        else {
          if (value) {
            element.value = value
          }
          else {
            element.value = element.getAttribute("data-default-value")
          }
        }
      }
      else {
        console.warn("No element '%s' in form",name)
      }
    }
    this.setAttribute("state","using-previous")
  }

  onConnected() {
    const form = this.querySelector("form")
    if (!form) {
      this.logger.info("Something's wrong, cannot find a <form>")
      return
    }
    for (const element of form.elements) {
      if (element.value) {
        element.setAttribute("data-default-value",element.value)
      }
    }
  }

  update() {
    const mealSearch = this.querySelector(MealSearch.tagName)
    if (!mealSearch) {
      this.logger.info("No %s - this won't work",MealSearch.tagName)
    }
    if (this.#state == "fresh") {
      this.#details.close()
      mealSearch.close()
    }
    else if (this.#state == "eating-out") {
      this.#details.close()
      mealSearch.close()
    }
    else if ( (this.#state == "creating") || (this.#state == "using-previous") ) {
      this.#details.open()
      mealSearch.close()
      if (this.#state == "using-previous") {
        const nameField = this.querySelector("input[name=name]")
        if (nameField) {
          nameField.setAttribute("readonly","")
        }
        else {
          this.logger.info("Cannot find name field?!")
        }
      }
    }
    this.#eatingOutRadioButtons.onEatingOut(this.#eatingOutSelected)
    this.#eatingOutRadioButtons.onNotEatingOut(this.#notEatingOutSelected)
    mealSearch.addEventListener("addnew",this.#addNew)
    mealSearch.addEventListener("mealselected",this.#previousMealSelected)
  }

}
export default NewPlanByDatePage
